import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Sparkles, Check } from 'lucide-react';
import { API_BASE } from '@/utils/api';

export const thumbUrl = (id) => `${API_BASE}/qr-center/template-thumbnail/${id}`;

export const TemplateGallery = ({ templates, categories, filter, onFilter, selectedId, onSelect }) => {
  const list = filter === 'all' ? templates : templates.filter(t => t.category === filter);
  return (
    <Card data-testid="qr-template-gallery">
      <CardHeader className="pb-3 space-y-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-amber-500" />
          Plantilla de la hoja
        </CardTitle>
        <Select value={filter} onValueChange={onFilter}>
          <SelectTrigger data-testid="qr-template-category-filter"><SelectValue placeholder="Categoría" /></SelectTrigger>
          <SelectContent>
            {Object.entries(categories).map(([key, cat]) => (
              <SelectItem key={key} value={key}>{cat.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-[420px]">
          <div className="grid grid-cols-2 gap-3 pr-3">
            {list.map(t => {
              const active = selectedId === t.template_id;
              return (
                <button
                  key={t.template_id}
                  type="button"
                  data-testid={`qr-template-${t.template_id}`}
                  onClick={() => onSelect(t.template_id)}
                  className={`group relative rounded-lg overflow-hidden border-2 transition-[border-color,transform] duration-200 hover:-translate-y-0.5 ${active ? 'border-primary' : 'border-transparent hover:border-primary/40'}`}
                >
                  <img src={thumbUrl(t.template_id)} alt={t.name} loading="lazy" className="w-full aspect-[4/5] object-cover bg-muted" />
                  <div className="absolute bottom-0 inset-x-0 bg-black/65 text-white text-[10px] px-1 py-1 truncate">{t.name}</div>
                  {active && (
                    <div className="absolute top-1 right-1 w-5 h-5 rounded-full bg-primary text-primary-foreground flex items-center justify-center">
                      <Check className="w-3 h-3" />
                    </div>
                  )}
                </button>
              );
            })}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
};
